import { wrapWithModule } from 'src/utils/redux';

export const wrapWithNamespace = wrapWithModule('modules/addProducts');
